export function getCookie(name: string, defaultValue?: string): string | null {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  const value = match ? decodeURIComponent(match[2]) : null;

  if (value !== null) return value;
  if (defaultValue !== undefined) return defaultValue;

  return null;
}
